import { formatDate } from '@src/utils';
import { apiService } from '../ServiceApi';
import { getServiceURL } from '@src/env.config';
import { error } from 'console';
import {
  getJWTToken,
  isJWTExpired,
  removeJWTToken,
} from '@src/utils/tokenManager';

export const parentService = apiService.injectEndpoints({
  endpoints: (builder) => {
    return {
      getAllParentFiles: builder.query({
        query: (pData) => {
          return {
            method: 'POST',
            url: `cdbservice/${pData.search ? 'search' : 'tabCdbDashboard'}`,
            params: {},

            body: JSON.stringify({
              page: pData.page,
              pageSize: pData.pageSize,
              count: !pData?.count,

              userId: pData?.user?.userId || '',
              ...(pData.search
                ? {
                    customerName: pData.search.toUpperCase(),
                    isFav: !!pData?.favourites,
                  }
                : {
                    userType: pData?.user?.userType || '',
                    userFavourites: !!pData?.favourites,
                  }),
            }),
            headers: {
              'Content-Type': 'application/json',
            },
            overrideExisting: true,
          };
        },
      }),
      getChildFiles: builder.query({
        query: (pData) => {
          return {
            method: 'POST',
            url: `cdbservice/multiSubmitterList`,
            params: {},
            body: JSON.stringify({
              fileId: pData?.fileId,
              searchText: pData?.searchText.toUpperCase(),
              userType: pData?.userType,
              userId: pData?.userId,
            }),
            headers: {
              'Content-Type': 'application/json',
            },
          };
        },
      }),
      getFileDetails: builder.query({
        query: (setId) => {
          return {
            method: 'POST',
            url: `cdbservice/getFileDetails`,

            params: {},
            body: JSON.stringify({
              txnSetId: setId,
            }),
            overrideExisting: true,
          };
        },
      }),
      getReports: builder.query({
        query: (pData) => {
          return {
            method: 'POST',
            url: `cdbservice/${
              pData.search ? 'cdbViewSearchReports' : `cdbViewReports`
            }`,
            params: {},
            body: JSON.stringify({
              page: pData.page,
              pageSize: pData.pageSize,
              count: !pData?.count,
              rptType: pData?.reportType || '',
              fileId: pData?.fileId || '',
              transSetId: pData?.transSetId || '0',
              totalCount: pData?.count || '0',
              allDates: pData?.allDate || '',
              totalErrors: pData?.totalErrors || 0,
              errorsShown: pData?.errorsShown || 0,
              errorCode: pData?.errorCode || '',
              fieldCode: pData?.fieldCode,
              sbmtGrpId: pData?.sbmtGrpId || '',
              flProcDttm: formatDate(pData?.processingDt || ''),
              flRecvDttm: formatDate(pData?.fileRecvDate || ''),
              fileInd: pData?.fileInd ? pData?.fileInd : '1',
              sbmtGrpNm: pData?.sbmtGrpName || '',
              errorType: pData?.fieldCode,
              primarySort: pData?.primarySort || '',
              secondarySort: pData?.secondarySort || '',
              ...(pData.search
                ? { searchTest: pData.search.toUpperCase() }
                : {}),
            }),
          };
        },
      }),
      getDownloadReport: builder.query({
        query: (pData) => {
          return {
            method: 'POST',
            url: `cdbservice/cdbParentDownload`,
            headers: {
              Accept: 'application/json, text/plain, */*',
              'Accept-Language': 'en-US,en;q=0.9',

              'Content-Type': 'application/json',
            },
            params: {},
            body: {
              rptType: pData.reportType,
              sbmtGrpId: pData.sbmtGrpId,
              fileId: pData.fileId.toString(),
              transSetId: pData.transSetId.toString(),
              flProcDttm: pData.flProcDttm,
              flRecvDttm: pData.flRecvDttm,
              fileInd: pData.fileInd,
              sbmtGrpNm: pData.sbmtGrpNm,
              subscriberId: pData.sbmtGrpId,
              profType: pData.profType,
            },
          };
        },
      }),
      getDownloadReportGps: builder.query({
        query: (pData) => {
          return {
            method: 'POST',
            url: `gpsservice/gpsDownload`,
            params: {},
            body: pData,
          };
        },
      }),
      getFamilyExchangeDetails: builder.query({
        query: (pData) => {
          return {
            method: 'POST',
            url: `cdbservice/fetchExchngFamily`,
            params: {},
            body: {
              page: 1,
              pageSize: 100,
              rptType: pData.reportType,
              fileId: pData.fileId,
              transSetId: pData.setId,
              totalCount: '0',
              allDates: 'string',
              sbmtGrpId: pData.sbmtGrpId,
              fileInd: '1',
              sbmtGrpNm: pData.customerName,
              subscriberId: pData.empId || pData.subscrId,
            },
          };
        },
      }),
      getDetailViewDetails: builder.query({
        query: (pData) => {
          return {
            method: 'POST',
            url: 'cdbservice/detailView',
            params: {},
            body: {
              transSetId: pData.transSetId,
              firstName: pData.firstName,
              lastName: pData.lastName,
              subscriberId: pData.empId,
              transFileId: pData.transFileId,
              cesCustomerNumber: pData.cescustnbr,
              ticRelCode: pData.relationship,
              transId: pData.transId,
              platform: 1,
            },
          };
        },
      }),
      getMonitor: builder.query({
        query: (txnSetId) => {
          return {
            method: 'POST',
            url: `cdbservice/MonitorView`,
            params: {},
            body: JSON.stringify({
              txnSetId,
            }),
            headers: {
              'Content-Type': 'application/json',
            },
          };
        },
      }),
      getProcStats: builder.query({
        query: (transSetId) => {
          return {
            method: 'POST',
            url: 'cdbservice/processingStatsReport/',
            params: {},
            body: JSON.stringify({
              transSetId: transSetId,
            }),

            headers: {
              'Content-Type': 'application/json',
            },
          };
        },
      }),
      setReprocessRejectChangeOwner: builder.query({
        query: (data) => {
          const { fileId, transSetId, distinationSystem } = data[0];

          // Remove fileId and transSetId from each item since they're already at the top level
          const sanitizedData = data.map(
            ({ fileId, transSetId, distinationSystem, ...rest }) => rest
          );

          return {
            method: 'POST',
            url: 'reprocess/reprocessRejectChangeOwner/',
            params: {},
            body: JSON.stringify({
              data: sanitizedData, // Send only unique fields per record
              fileId,
              transSetId,
              distinationSystem,
            }),
            headers: {
              'Content-Type': 'application/json',
            },
          };
        },
      }),
      setReprocessRejectChangeOwnerAll: builder.query({
        query: (data) => {
          return {
            method: 'POST',
            url: 'reprocess/reprocessRejectChangeOwnerAll/',
            params: {},
            body: JSON.stringify({
              sbmtGrpId: data.sbmtGrpId,
              fileId: data.fileId,
              transSetId: data.transSetId,
              flProcDttm: data.flProcDttm,
              action: data.action,
              xcptTypeTxt: data.errortype,
              xcptTypeCode: data.errorCode,
              allDates: data.allDates,
              platform: data.platform,
            }),
            headers: {
              'Content-Type': 'application/json',
            },
          };
        },
      }),
      setCustomerCorrChangeOwner: builder.query({
        query: (data) => {
          const { fileId, transSetId, distinationSystem } = data[0];

          // Remove fileId and transSetId from each item since they're already at the top level
          const sanitizedData = data.map(
            ({ fileId, transSetId, distinationSystem, ...rest }) => rest
          );

          return {
            method: 'POST',
            url: 'reprocess/customerCorrChangeOwner/',
            params: {},
            body: JSON.stringify({
              data: sanitizedData, // Send only unique fields per record
              fileId,
              transSetId,
              distinationSystem,
            }),
            headers: {
              'Content-Type': 'application/json',
            },
          };
        },
      }),
      setContinueProcessing: builder.query({
        query: ({ tranSetId, tranFileId }) => {
          return {
            method: 'POST',
            url: 'reprocess/continueProcessing',
            params: {},
            body: {
              businessProcessId: 'GatewayOnlineReprocess',
              tranSetId,
              tranFileId,
            },
          };
        },
      }),
      getRejectReprocessing: builder.query({
        query: ({ tranSetId, tranFileId }) => {
          return {
            method: 'POST',
            url: 'reprocess/reject-Reprocessing',
            params: {},
            body: {
              businessProcessId: 'GatewayOnlineReprocess',
              tranSetId,
              tranFileId,
            },
          };
        },
      }),
      getOverrideReprocessing: builder.query({
        query: ({ tranSetId, tranFileId }) => {
          return {
            method: 'POST',
            url: 'reprocess/override-Reprocessing',
            params: {},
            body: {
              businessProcessId: 'GatewayOnlineReprocess',
              tranSetId,
              tranFileId,
            },
          };
        },
      }),
      getNoOverrideReprocessing: builder.query({
        query: ({ tranSetId, tranFileId }) => {
          return {
            method: 'POST',
            url: 'reprocess/noOverride-Reprocessing',
            params: {},
            body: {
              businessProcessId: 'GatewayOnlineReprocess',
              tranSetId,
              tranFileId,
            },
          };
        },
      }),
    };
  },
});
export const downloadFile = (requestBody, apiUrl, setIsLoading) => {
  setIsLoading(true);

  // Build headers, attaching JWT if available and not expired
  const downloadHeaders: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  const jwtToken = getJWTToken();
  if (jwtToken && !isJWTExpired()) {
    downloadHeaders['Authorization'] = `Bearer ${jwtToken}`;
  }

  fetch(`${getServiceURL()}${apiUrl}`, {
    method: 'POST',
    headers: downloadHeaders,
    // Required so the browser sends the HttpOnly auth cookie
    credentials: 'include',
    body: JSON.stringify(requestBody),
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error('Network response was not ok');
      }
      const contentDisposition = res.headers.get('Content-Disposition');
      let filename = 'download_report.csv'; // Default filename if not found in headers
      if (contentDisposition && contentDisposition.includes('filename=')) {
        filename = contentDisposition
          .split('filename=')[1]
          .split(';')[0]
          .trim();

        if (filename.startsWith('"') && filename.endsWith('"')) {
          filename = filename.slice(1, -1);
        }
      }
      return res.blob().then((blob) => ({ blob, filename }));
    })
    .then(({ blob, filename }) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = filename; // Use the extracted filename
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      // If response was 401, JWT is expired/invalid — clear it and redirect to login
      if (error?.message?.includes('401') || error?.status === 401) {
        removeJWTToken();
        window.location.href = '/logout';
      }
      console.error('Error fetching data:', error);
    })

    .finally(() => {
      setIsLoading(false); // Stop loader
    });
};

export const {
  useLazyGetAllParentFilesQuery,
  useLazyGetDownloadReportQuery,
  useLazyGetDownloadReportGpsQuery,
  useGetAllParentFilesQuery,
  useGetChildFilesQuery,
  useLazyGetChildFilesQuery,
  useGetFileDetailsQuery,
  useLazyGetReportsQuery,
  useGetReportsQuery,
  // useGetDetailViewDetailsQuery,
  useLazyGetDetailViewDetailsQuery,
  useGetMonitorQuery,
  useGetProcStatsQuery,
  useLazySetReprocessRejectChangeOwnerQuery,
  useLazySetReprocessRejectChangeOwnerAllQuery,
  useLazySetCustomerCorrChangeOwnerQuery,
  useLazySetContinueProcessingQuery,
  useLazyGetRejectReprocessingQuery,
  useLazyGetOverrideReprocessingQuery,
  useLazyGetNoOverrideReprocessingQuery,
  useLazyGetFamilyExchangeDetailsQuery,
} = parentService;
